// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1o58Y","link":"style_link__1pnil","navigation":"style_navigation__1ooma"};